<template>
    <div v-if="showCofidisBlock">
        <div class="financing-available clearfix">
            <a class="cofidis-learn-more track-GA4-event row" data-ga4_name="financing_prequalify" :data-ga4_model_category="activePartnumber.GA_Category" :data-ga4_model_name="activePartnumber.GA_ModelName" data-ga4_click_text="prequalify now" data-toggle="modal" data-target="#ModalCofidisVue" style="cursor: pointer; min-height: 30px;">
                <div class="col-md-8 col-xs-6">{{ teaserLabel }}</div>
                <div class="col-md-4 col-xs-6 text-right"><img :src="cdn + '/Images/Shared/Icons/icon_cofidis.png'" alt="Cofidis" /></div>
            </a>
        </div>
        <div class="modal modal-for-financing" tabindex="-1" role="dialog" id="ModalCofidisVue" style="top: 100px;">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <img :src="stylesCdn + '/Images/Shared/Icons/icon_cofidis.png'" alt="Cofidis" />
                    </div>
                    <div class="modal-body"> 
                        
                        <div class="cf-calculator cofidis-calculator">
                            <p v-if="loadingRows" class="text-muted" style="font-size: 12px;">{{ labelLoading }}</p>
                            <table v-else class="financing">
                                <tbody>
                                    <tr class="heading">
                                        <th v-html="labelColInstallmentsMonths"></th>
                                        <th v-html="labelColMonthlyRate"></th>
                                        <th v-html="labelColApr"></th>
                                        <th v-html="labelColFinancingType"></th>
                                        <th v-html="labelColTotalAmount"></th>
                                    </tr>
                                    <tr v-for="(row, idx) in tableRows" :key="idx">
                                        <td>{{ row.installmentsMonths }}</td>
                                        <td>{{ row.monthlyRate }}</td>
                                        <td>{{ row.apr }}</td>
                                        <td>{{ row.financingType }}</td>
                                        <td>{{ row.totalAmount }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p v-if="!loadingRows && tableRows.length === 0" class="text-muted" style="font-size: 12px;">{{ labelUnavailable }}</p>
                            <div class="conditions">
                                {{ labelDisclaimer }}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{ labelClose }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import generalMixin from '../../mixins/general.js';

    export default {
        name: 'Cofidis',
        mixins: [generalMixin],
        props: ['activePartnumber'],
        data: function () {
            return {
                paymentOptions: window.paymentOptions,
                cdn: window.cdn,
                stylesCdn: window.stylesCdn || window.cdn,
                teaserLabel: '',
                tableRows: [],
                loadingRows: false
            };
        },
        computed: {
            showCofidisBlock() {
                if (!this.activePartnumber || !this.paymentOptions || this.paymentOptions.length === 0) return false;
                const p = Number(this.activePartnumber.Price);
                if (!Number.isFinite(p)) return false;
                const po = this.paymentOptions;
                const has3 = po.some(x => x.Provider === 'Cofidis_PayIn3');
                const has4 = po.some(x => x.Provider === 'Cofidis_PayIn4');
                const hasLoan = po.some(x => x.Provider === 'Cofidis_Finance');
                if (has3 && p >= 100 && p <= 3000) return true;
                if (has4 && p >= 100 && p <= 3000) return true;
                if (hasLoan && p >= 1000 && p <= 6000) return true;
                return false;
            },
            labelColInstallmentsMonths() {
                return this.lookupText('shop_cofidis_col_installments_months', '\u00C9ch\u00E9ances<br>(en mois)');
            },
            labelColMonthlyRate() {
                return this.lookupText('shop_cofidis_col_monthly_rate', 'Mensualit\u00E9');
            },
            labelColApr() {
                return this.lookupText('shop_cofidis_col_apr', 'TAEG');
            },
            labelColFinancingType() {
                return this.lookupText('shop_cofidis_col_financing_type', 'Type<br>(carte / pr\u00EAt)');
            },
            labelColTotalAmount() {
                return this.lookupText('shop_cofidis_col_total_amount', 'Montant<br>total');
            },
            labelDisclaimer() {
                const fbPlain =
                    "Simulation indicative. Le co\u00FBt du cr\u00E9dit d\u00E9pend de votre dossier. Offre sous r\u00E9serve d'acceptation par Cofidis.";
                let t = this.lookupText('shop_cofidis_pdp_disclaimer', fbPlain);
                if (t !== fbPlain && (t.indexOf('\u00c3') >= 0 || t.indexOf('\u00c2') >= 0)) {
                    t = fbPlain;
                }
                if (t.indexOf('<') >= 0) {
                    return t;
                }
                return (
                    '<span style="font-size:9px;line-height:1.4;color:#666;font-weight:normal">' +
                    this.encodeHtmlNumericEntities(t) +
                    '</span>'
                );
            },
            labelUnavailable() {
                return this.lookupText('shop_cofidis_pdp_simulation_unavailable', 'Simulation temporairement indisponible.');
            },
            labelLoading() {
                return this.lookupText('loading', 'Loading...');
            },
            labelClose() {
                return this.lookupText('close', 'Close');
            }
        },
        watch: {
            activePartnumber: {
                handler() {
                    this.refreshTeaserAndTable();
                },
                deep: true
            }
        },
        methods: {
            escapeHtml(text) {
                if (text == null || text === '') {
                    return '';
                }
                return String(text)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;');
            },
            /** Escape ASCII markup chars and encode non-ASCII as decimal numeric entities (avoids mojibake in mixed encodings). */
            encodeHtmlNumericEntities(text) {
                if (text == null || text === '') {
                    return '';
                }
                const s = String(text);
                let out = '';
                for (let i = 0; i < s.length; ) {
                    const cp = s.codePointAt(i);
                    i += cp > 0xffff ? 2 : 1;
                    if (cp === 38) {
                        out += '&amp;';
                    } else if (cp === 60) {
                        out += '&lt;';
                    } else if (cp === 62) {
                        out += '&gt;';
                    } else if (cp === 34) {
                        out += '&quot;';
                    } else if (cp <= 127) {
                        out += String.fromCodePoint(cp);
                    } else {
                        out += '&#' + cp + ';';
                    }
                }
                return out;
            },
            lookupText(key, fallback) {
                if (this.interfaceTexts && this.interfaceTexts.length > 0) {
                    const obj = this.interfaceTexts.find(o => o.Key === key);
                    if (obj && obj.Value) return obj.Value;
                }
                return fallback;
            },
            async fetchSimAll(amount) {
                const url = '/' + window.culture + '/shop/cofidis-simulate-all?amount=' + encodeURIComponent(amount);
                const res = await axios.get(url);
                return res.data;
            },
            installmentsForOption(data, code) {
                if (!data || !data.success || !data.options || !data.options.length) return null;
                const o = data.options.find(x => (x.paymentOption || '').toUpperCase() === code);
                return o && o.installments && o.installments.length ? o.installments : null;
            },
            optionByPaymentCode(data, code) {
                if (!data || !data.success || !data.options || !data.options.length) return null;
                return data.options.find(x => (x.paymentOption || '').toUpperCase() === code) || null;
            },
            /** Pay in 3/4: €100–€3000. Finance: €1000–€6000. Also guards API rows returned out of band. */
            isCofidisOptionInPriceBand(paymentOption, amount) {
                const code = (paymentOption || '').toUpperCase();
                const p = Number(amount);
                if (!Number.isFinite(p)) return false;
                if (code === '3X' || code === '4X') return p >= 100 && p <= 3000;
                if (code === 'LOAN') return p >= 1000 && p <= 6000;
                return false;
            },
            financingTypeLabel(key) {
                const k = (key || '').toLowerCase();
                if (k === 'payin3_cb') {
                    return this.lookupText('shop_cofidis_financing_type_payin3_cb', 'Paiement carte \u2014 3\u00D7');
                }
                if (k === 'payin4_cb') {
                    return this.lookupText('shop_cofidis_financing_type_payin4_cb', 'Paiement carte \u2014 4\u00D7');
                }
                if (k === 'loan') {
                    return this.lookupText('shop_cofidis_financing_type_loan', 'Cr\u00E9dit personnel');
                }
                return key || '';
            },
            optionSummaryRow(opt) {
                if (!opt) return null;
                const monthlyRate = opt.monthlyRate != null ? opt.monthlyRate : opt.MonthlyRate;
                if (!monthlyRate) return null;
                return {
                    installmentsMonths: opt.installmentsMonthsDisplay != null ? opt.installmentsMonthsDisplay : opt.InstallmentsMonthsDisplay,
                    monthlyRate: monthlyRate,
                    apr: opt.apr != null ? opt.apr : opt.Apr,
                    financingType: this.financingTypeLabel(opt.financingTypeKey != null ? opt.financingTypeKey : opt.FinancingTypeKey),
                    totalAmount: opt.totalAmount != null ? opt.totalAmount : opt.TotalAmount
                };
            },
            /** Compare teaser options: lowest first instalment (parsed from formatted amountDisplay). */
            firstInstalmentSortKey(opt) {
                const inst = opt && opt.installments ? opt.installments : opt && opt.Installments ? opt.Installments : null;
                if (!inst || !inst.length) return Number.POSITIVE_INFINITY;
                const first = inst[0];
                const raw = first.amountDisplay != null ? first.amountDisplay : first.AmountDisplay;
                if (!raw || typeof raw !== 'string') return Number.POSITIVE_INFINITY;
                const cleaned = raw.replace(/\s/g, '').replace(/[^\d,.-]/g, '');
                const normalized = cleaned.indexOf(',') >= 0 && cleaned.indexOf('.') >= 0
                    ? cleaned.replace(/\./g, '').replace(',', '.')
                    : cleaned.replace(',', '.');
                const n = parseFloat(normalized);
                return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
            },
            async refreshTeaserAndTable() {
                if (!this.showCofidisBlock || !this.activePartnumber) return;
                const p = Number(this.activePartnumber.Price);
                if (!Number.isFinite(p)) return;
                const po = this.paymentOptions;
                this.teaserLabel = this.lookupText('shop_cofidis_pdp_teaser_fallback', 'Financez votre achat avec Cofidis');
                const tMonth = this.lookupText('shop_or_finance_from_per_month', 'or finance from {0} per month');
                try {
                    const d = await this.fetchSimAll(p);
                    const candidates = [];
                    const pushRow = (opt) => {
                        if (!opt) return;
                        const code = (opt.paymentOption || opt.PaymentOption || '').toUpperCase();
                        if (!this.isCofidisOptionInPriceBand(code, p)) return;
                        const row = this.optionSummaryRow(opt);
                        if (row && row.monthlyRate) {
                            candidates.push({ row, opt });
                        }
                    };
                    if (po.some(x => x.Provider === 'Cofidis_PayIn3')) {
                        pushRow(this.optionByPaymentCode(d, '3X'));
                    }
                    if (po.some(x => x.Provider === 'Cofidis_PayIn4')) {
                        pushRow(this.optionByPaymentCode(d, '4X'));
                    }
                    if (po.some(x => x.Provider === 'Cofidis_Finance')) {
                        (d.options || []).filter(x => (x.paymentOption || '').toUpperCase() === 'LOAN').forEach(pushRow);
                    }
                    if (candidates.length > 0) {
                        candidates.sort((a, b) => this.firstInstalmentSortKey(a.opt) - this.firstInstalmentSortKey(b.opt));
                        this.teaserLabel = tMonth.replace('{0}', candidates[0].row.monthlyRate);
                    }
                } catch (e) { /* ignore */ }
            },
            async loadModalTable() {
                if (!this.showCofidisBlock || !this.activePartnumber) return;
                this.loadingRows = true;
                this.tableRows = [];
                const p = Number(this.activePartnumber.Price);
                if (!Number.isFinite(p)) {
                    this.loadingRows = false;
                    return;
                }
                const po = this.paymentOptions;
                const rows = [];
                try {
                    const d = await this.fetchSimAll(p);
                    const pushIf = (opt) => {
                        if (!opt) return;
                        const code = (opt.paymentOption || opt.PaymentOption || '').toUpperCase();
                        if (!this.isCofidisOptionInPriceBand(code, p)) return;
                        const row = this.optionSummaryRow(opt);
                        if (row) rows.push(row);
                    };
                    if (po.some(x => x.Provider === 'Cofidis_PayIn3')) {
                        pushIf(this.optionByPaymentCode(d, '3X'));
                    }
                    if (po.some(x => x.Provider === 'Cofidis_PayIn4')) {
                        pushIf(this.optionByPaymentCode(d, '4X'));
                    }
                    if (po.some(x => x.Provider === 'Cofidis_Finance')) {
                        (d.options || []).filter(x => (x.paymentOption || '').toUpperCase() === 'LOAN').forEach(pushIf);
                    }
                } finally {
                    this.loadingRows = false;
                }
                this.tableRows = rows;
            }
        },
        created() {
            var el = document.getElementById('vue-parameters');
            if (el && el.dataset.interfacetexts) {
                this.interfaceTexts = JSON.parse(el.dataset.interfacetexts);
            }
            this.refreshTeaserAndTable();
        },
        mounted() {
            var self = this;
            var $jq = window.jQuery || window.$;
            if ($jq) {
                $jq('#ModalCofidisVue').on('show.bs.modal', function () {
                    self.loadModalTable();
                });
            }
        }
    };
</script>
